import React, { useRef } from 'react';
import { translate } from '@utils/i18n';
import { Button } from '../../../../../../ui/atoms/Button/Button';
import { PROMPT_SUGGESTIONS } from '../../../../constants/prompts';
import './PromptSuggestionsStyles.scss';
const BASE_CLASS = 'ai-chat-prompt-suggestions';
const I18N_NAMESPACE = 'features.ai_chat_widget.prompt_suggestions';
// Roving-tabindex arrow-key navigation within the chip group (WAI-ARIA
// "Toolbar"/button-group pattern) — Tab enters/exits the group as one stop,
// ArrowLeft/ArrowRight move focus between chips. Required alongside
// role="group": ARIA semantics without matching keyboard behavior are worse
// than no ARIA at all.
function handleGroupKeyDown(event) {
    var _a;
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')
        return;
    const buttons = Array.from(event.currentTarget.querySelectorAll('button'));
    const currentIndex = buttons.indexOf(document.activeElement);
    if (currentIndex === -1)
        return;
    event.preventDefault();
    const delta = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (currentIndex + delta + buttons.length) % buttons.length;
    (_a = buttons[nextIndex]) === null || _a === void 0 ? void 0 : _a.focus();
}
export function PromptSuggestions({ onSelectPrompt, suggestions = PROMPT_SUGGESTIONS, groupLabel, onChipSelect }) {
    const groupRef = useRef(null);
    const resolvedGroupLabel = groupLabel !== null && groupLabel !== void 0 ? groupLabel : translate('default_group_label', { namespace: I18N_NAMESPACE });
    return (React.createElement("div", { ref: groupRef, className: BASE_CLASS, role: "group", "aria-label": resolvedGroupLabel, "aria-live": "polite", onKeyDown: handleGroupKeyDown }, suggestions.map((suggestion) => (React.createElement(Button, { key: suggestion.label, variant: "secondary", "aria-label": suggestion.label, onClick: () => {
            onChipSelect === null || onChipSelect === void 0 ? void 0 : onChipSelect(suggestion);
            onSelectPrompt(suggestion.prompt);
        } }, suggestion.label)))));
}
